import React, { useEffect, useState } from "react";
import DacTable from "./DacTable";
import DacTableSearch from "./DacTableSearch";
import "./styles/Dac.css";
import DacModal from "./DacModal";
import { useDispatch, useSelector } from "react-redux";
import {getDacAllRequest, initiliseDacReduerState } from "../../../../../../redux/actions/adminAccount-actions/dac-actions";
import ModalMainContainer from "../../../../../ModalNotification/ModalMainContainer";
import CircularProgressLoader from "../../../../../../components/common/CircularProgressLoader";

const Dac = () => {
  const [isDacModalOpen, setDacModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitActive, setIsSubmitActive] = useState(false);
  const [modalMessage, setModalMessage] = useState([]);
  const [isSubmitSuceess, setIsSubmitSuccess] = useState(false);
  const [rowData, setRowData] = useState({});
  const [isEditRequest, setIsEditRequest] = useState(false);
  const [searchText, setSearchText] = useState("");
  // const [deleteDacId, setDeleteDacId] = useState(null);
  const dispatch = useDispatch();

  const { isRequestCompleted, isRequestSuccess, message, loading } = useSelector((state) => ({
    isRequestCompleted : state.DacReducer.isRequestCompleted,
    isRequestSuccess : state.DacReducer.isRequestSuccess,
    message : state.DacReducer.message,
    loading : state.DacReducer.loading
  }));

  useEffect(() => {
    dispatch(getDacAllRequest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(() => {
    if(isRequestCompleted){
      setIsSubmitActive(true);
      if(isRequestSuccess){
        setIsSubmitSuccess(true);
        setDacModalOpen(false);
      }else{
        setIsSubmitSuccess(false);
      }
      setModalMessage(message);
      setIsModalOpen(true);
      dispatch(initiliseDacReduerState());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isRequestCompleted]);

  const editDacModal = (rowData) => {
    setIsEditRequest(true);
    setRowData(rowData);
    setDacModalOpen(true);
  };

  // const handleDelete = (dacId) => {
  //   setDeleteDacId(dacId);
  //   setIsSubmitActive(false);
  //   setModalMessage(["Are you sure you want to delete this dac?"]);
  //   setIsModalOpen(true);
  // };

  const toggleOpenDacModal = () => {
    setIsEditRequest(false);
    setDacModalOpen(!isDacModalOpen);
  };

  const handleReactivate = () => {
    setIsModalOpen(false);
    // dispatch(deleteDacRequest(deleteDacId));
  };

  if(loading){
    return <CircularProgressLoader />;
  }

  return (
    <div className="dacContainer">
      <DacTableSearch 
        openDacModal={toggleOpenDacModal}
        setSearchText={setSearchText}
       />
      <DacTable 
        openDacModal={editDacModal}
        searchText={searchText}
        // handleDelete={handleDelete}
      />
      <DacModal
        isModalOpen={isDacModalOpen}
        toggleOpenDacModal={toggleOpenDacModal}
        rowData={rowData}
        isEditRequest={isEditRequest}
      />
      <ModalMainContainer 
        isModalOpen={isModalOpen} 
        setIsModalOpen={setIsModalOpen} 
        isSubmitActive={isSubmitActive}
        modalMessage={modalMessage}
        isSubmitSuceess={isSubmitSuceess}
        reactivate={true}
        handleReactivate={handleReactivate}
        toggleToLandingPage={() => {
          setIsModalOpen(false);
          // setDeleteDacId(null);
        }}
      />
    </div>
  );
};

export default Dac;
